export enum SortingOrder {
    None = 'None',
    Descending = 'Descending',
    Ascending = 'Ascending',
}
